module.exports = __webpack_public_path__ + "static/media/13.9247e325.png";